module.exports = __webpack_public_path__ + "img/notification.f970336a.svg";